import { createTracker } from 'usage-tracker';
import events from 'knowledge-content-ui/events.yaml';
import { APP_NAME } from '../constants/TrackingConstants';
import userInfo from 'hub-http/userInfo';
import { isUngatedForKnowledgeBaseV3_1 } from './gatesUtils';
import { setPrimaryTracker } from 'usage-tracker-container';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
const tracker = createTracker({
  events,
  properties: {
    namespace: APP_NAME,
    isLegacyKnowledgeBase: () => userInfo().then(auth => !isUngatedForKnowledgeBaseV3_1(auth.gates))
  }
});
setPrimaryTracker(tracker, REPORTING_TRACKER);
export const beforeUnloadTracker = createTracker({
  events,
  properties: {
    namespace: APP_NAME,
    isBeforeUnload: true,
    isLegacyKnowledgeBase: () => userInfo().then(auth => !isUngatedForKnowledgeBaseV3_1(auth.gates))
  }
});
export const usageTrackerForFrameworkListingLib = tracker.clone({
  lastKnownEventProperties: ['screen']
});
export default tracker;